/* eslint-disable no-control-regex */
import { Quill } from 'vue-quill-editor';
import _ from 'lodash';
import { getCharactersToRetain } from './textHelper';

const Delta = Quill.import('delta');

const maxLengthModule = function (quill, options) {
  //we register an onchange eventHandler in the module
  //quill on text-change fires after a user makes a change. delta is the change made and oldDelta, the text before the change.
  //Important to not the change has already happenned at this point.
  //also important to note that whatever we do must be short & pretty quick to keep up with typing & deleting speed.
  quill.on('text-change', function (delta, oldDelta, source) {
    if (source != 'user') {
      return;
    }
    //get all contents in the editor right now
    //I find this call to be a little slow in responsiveness
    //Potentially we could add 'delta' to 'oldDelta' and get the current content of the editor that way (may be an optimisation)
    const content = quill.getContents();

    //retain returns the number of quill characters to keep.
    //Length returns how we count characters (to quill a mention is one character to the editor mentions have weightings it 15characters)
    //ops are the operations that make up a delta. if you add a delta to an editor it performs these ops.
    //quill.getContents() returns a delta whose ops are all text 'inserts' needed to create that editors content.
    //ie as editor with 'Hi @FirstName' would have a delta with the ops = [{ insert: 'Hi'}, {insert: { mention } }]
    const { retain, length } = getCharactersToRetain(
      content.ops,
      options.maxLength,
      options.mentionWeight
    );
    //the new content retains the characters from getCharactersToRetain and simply deletes everything else.
    //there is no delete(everything else) method so I send the length of the original content which should delete everything else
    const newDelta = new Delta().retain(retain).delete(content.length());
    options.getLength(length);

    //silently append out changes
    quill.updateContents(newDelta, 'silent');
  });
};

export default maxLengthModule;
